import $ from "jquery";

export const showBackdrop = function (options) {
  const backdrop = $("<div>").addClass("backdrop").attr("id", options.id).attr("data-qa-id", options.qa_id);

  backdrop.css(options.style || {});
  if (options.opacity || options.opacity === 0) {
    backdrop.css("opacity", options.opacity);
  }

  backdrop.one("click", function () {
    backdrop.remove();
    if (options.onclick) {
      return options.onclick();
    }
  });

  return $("body").append(backdrop);
};

export const hideBackdrop = (options) => $(`#${options.id}`).remove();
